import type { ApiClient } from '../client';

// Force a «Entrega» to Collected (manual pickup override). The id rides the path
// (url-encoded); the client attaches the Firebase token via the Authorization header,
// never the URL. The endpoint answers an empty 200 — there is nothing to parse; the
// caller refetches the detail to surface the new Collected state and the «Recogido» row.
export async function confirmDeliveryCollect(client: ApiClient, id: string): Promise<void> {
  await client.post(`/app_service/panel/v1/deliveries/${encodeURIComponent(id)}/collect`);
}
